import React from 'react';
import { FundItem } from '../../../../models/Fund';
import ContentBox from '../../../common/ContentBox';
import { Box, ITheme, SvgIcon, Tooltip, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ReactComponent as cogIcon } from '../../../../assets/cog.svg';
import { ReactComponent as moneybagIcon } from '../../../../assets/moneybag.svg';
import { ReactComponent as balanceIcon } from '../../../../assets/balance.svg';
import { ReactComponent as heartbeatIcon } from '../../../../assets/heartbeat.svg';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

export interface IOverviewFeeOtherProps {
    fund: FundItem;
}

const OverviewFeeOther: React.FC<IOverviewFeeOtherProps> = ({ fund }) => {
    const { t } = useTranslation();
    const theme = useTheme() as ITheme;

    const renderItemData = (name: string, value: string, icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>, description?: string) => {
        return <Box display={"flex"} gap={"15px"} alignItems={"center"}>
            {icon ?
                <SvgIcon component={icon} inheritViewBox sx={{ width: "30px", height: "30px", color: theme.palette.primary.dark }} />
                :
                <div style={{ width: "30px", height: "30px" }}></div>
            }
            <Box display={"flex"} flexDirection={"column"} gap={"4px"}>
                <Box display={"flex"} gap={"11px"} alignItems={"center"}>
                    <Typography fontSize={"16px"} fontWeight={"400"} lineHeight={"19.5px"}>{name}</Typography>
                    <Tooltip title={description} arrow>
                        <HelpOutlineIcon fontSize='small' />
                    </Tooltip>
                </Box>
                <Typography fontSize={"20px"} fontWeight={"600"} lineHeight={"24.38px"}>{value}</Typography>
            </Box>
        </Box>
    }

    return <ContentBox proportion={1}>
        <Box display={"flex"} flexDirection={"column"} gap={"10px"}>
            <Typography fontSize={"18px"} lineHeight={"21.94px"} fontWeight={"600"}>{t('LibraryOfFundsOverviewTabFeeTitle')}</Typography>
            {renderItemData(t('LibraryOfFundsOverviewTabFeeManagement'), `${Math.floor(fund.managementFees * 100)}%`, cogIcon, t('LibraryOfFundsOverviewTabFeeManagementDescription'))}
            {renderItemData(t('LibraryOfFundsOverviewTabFeeCarry'), `${Math.floor(fund.carryFees * 100)}%`, moneybagIcon, t('LibraryOfFundsOverviewTabFeeCarryDescription'))}
            {renderItemData(t('LibraryOfFundsOverviewTabFeeHurdle'), `${Math.floor(fund.hurdleRate * 100)}%`, balanceIcon, t('LibraryOfFundsOverviewTabFeeHurdleDescription'))}
            {renderItemData(t('LibraryOfFundsOverviewTabFeeFundLife'), fund.fundLife, heartbeatIcon, t('LibraryOfFundsOverviewTabFeeFundLifeDescription'))}
        </Box>
    </ContentBox>
}

export default OverviewFeeOther;